const PHOTOS = {
  trucksWithPump: "https://customer-assets.emergentagent.com/job_concrete-orders-48h/artifacts/tazawk76_d729ffdf-05c2-4d02-8b27-b36ee1602345.jpeg",
  trucksFleet: "https://customer-assets.emergentagent.com/job_concrete-orders-48h/artifacts/s4plevus_643b4520-dd0e-4d58-b705-05f56a4af608.jpeg",
  silozuri: "https://customer-assets.emergentagent.com/job_concrete-orders-48h/artifacts/or0w6zlh_48e66ce2-c2fa-4356-b582-e5c497f354b2.jpeg",
  birou: "https://customer-assets.emergentagent.com/job_concrete-orders-48h/artifacts/8vbht0om_E59E2C72-4746-4FC2-9DA1-62E8B0444E62.png",
};

export default function Fleet() {
  return (
    <section data-testid="fleet-section" className="py-20 sm:py-32 bg-[#FAFAFA] border-t border-black/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#F59E0B] mb-6">
              · 04 / STAȚIE & FLOTĂ
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight">
              Stația<br />
              Noastră.
            </h2>
          </div>
          <p className="max-w-md text-sm sm:text-base text-neutral-700 leading-relaxed">
            Stație proprie cu silozuri de ciment, sediu administrativ și flotă completă
            de autobetoniere și pompă de beton — Fetești și Slobozia.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 sm:gap-6">
          {/* Big: autobetoniere + pompă */}
          <PhotoCard
            className="col-span-12 lg:col-span-8 h-[320px] sm:h-[440px] lg:h-[520px]"
            src={PHOTOS.trucksWithPump}
            alt="Flota Apolodor Com SRL - autobetoniere și pompă"
            tag="Autobetoniere + Pompă beton"
            dark
            testid="fleet-photo-pump"
          />

          {/* Right column */}
          <div className="col-span-12 lg:col-span-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 sm:gap-6">
            <PhotoCard
              className="h-[260px] sm:h-[280px] lg:h-[250px]"
              src={PHOTOS.silozuri}
              alt="Silozuri ciment stație Apolodor"
              tag="Silozuri ciment"
              amber
              testid="fleet-photo-silozuri"
              objectPosition="center 60%"
            />
            <PhotoCard
              className="h-[260px] sm:h-[280px] lg:h-[250px]"
              src={PHOTOS.birou}
              alt="Sediul administrativ Apolodor Com SRL"
              tag="Sediu administrativ"
              dark
              testid="fleet-photo-birou"
              objectPosition="center 45%"
            />
          </div>

          {/* Bottom row */}
          <PhotoCard
            className="col-span-12 md:col-span-8 h-[280px] sm:h-[360px]"
            src={PHOTOS.trucksFleet}
            alt="Flotă autobetoniere Apolodor Com SRL"
            tag="Flotă autobetoniere"
            amber
            testid="fleet-photo-fleet"
          />

          <div className="col-span-12 md:col-span-4 bg-[#0A0A0A] text-white p-6 sm:p-8 flex flex-col justify-between min-h-[280px] sm:min-h-[360px]">
            <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
              Capabilități
            </div>
            <div>
              <div className="font-display text-3xl sm:text-4xl leading-[0.95] tracking-tight uppercase">
                Producție<br />
                & livrare<br />
                pe șantier
              </div>
              <div className="text-xs text-neutral-400 mt-4 leading-relaxed">
                Silozuri proprii · Flotă autobetoniere · Pompă beton · Programări 48h
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PhotoCard({ src, alt, tag, className, dark, amber, testid, objectPosition }) {
  return (
    <div className={`relative group overflow-hidden border border-black/10 ${className}`}>
      <img
        src={src}
        alt={alt}
        data-testid={testid}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        style={{ objectPosition: objectPosition || "center 65%" }}
        loading="lazy"
      />
      <div
        className={`absolute bottom-0 left-0 px-5 py-3 font-mono-tech text-[10px] tracking-[0.2em] uppercase ${
          amber ? "bg-[#F59E0B] text-black font-bold" : dark ? "bg-[#0A0A0A] text-white" : "bg-white text-black"
        }`}
      >
        {tag}
      </div>
    </div>
  );
}

/**
 * Reserved for future use if any photo needs CSS rotation.
 */
// eslint-disable-next-line no-unused-vars
function BiroFotoCard({ src, className, testid }) {
  return (
    <div className={`relative group overflow-hidden border border-black/10 bg-[#0A0A0A] ${className}`}>
      <div
        data-testid={testid}
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${src})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        role="img"
      />
    </div>
  );
}
